import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryPointDetails } from '../types/delivery-point-details.type';
import { ADMIN_DELIVERY_POINTS_API_PATHS } from '../constants/delivery-points-api-paths.constants';

type UseRestoreDeliveryPointResult = {
  restoreDeliveryPoint: (deliveryPointId: string) => Promise<DeliveryPointDetails | null>;
  isSubmitting: boolean;
};

export function useRestoreDeliveryPoint(): UseRestoreDeliveryPointResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreDeliveryPoint = async (deliveryPointId: string): Promise<DeliveryPointDetails | null> => {
    setIsSubmitting(true);

    try {
      const restoredDeliveryPoint = await HttpClient.post<DeliveryPointDetails>(
        ADMIN_DELIVERY_POINTS_API_PATHS.RESTORE_DELIVERY_POINT(deliveryPointId)
      );

      enqueueSnackbar('Point de livraison restauré', { variant: 'success' });
      return restoredDeliveryPoint;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(
          error,
          'Une erreur est survenue lors de la restauration du point de livraison'
        ),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreDeliveryPoint, isSubmitting };
}
